import ServiceCategoryCard from "../../components/services/ServiceCategoryCard";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import useAppData from "../../hooks/useAppData";

const Services = () => {
	const { categories, servicePage } = useAppData();

	return (
		<>
			<Helmet>
				<title>{servicePage.meta_title}</title>
				<meta name="description" content={servicePage.meta_description} />
				<meta name="keywords" content={servicePage.meta_keywords} />
			</Helmet>
			<section>
				<Container fluid className="p-0 service-page__banner">
					<Row className="g-0">
						<Col
							md={6}
							lg={6}
							sm={12}
							xs={12}
							className="service-page__box d-flex justify-content-end align-items-center"
						>
							<img src="/assets/images/cardboard-boxes.png" alt="" />
						</Col>
						<Col
							md={6}
							lg={6}
							sm={12}
							xs={12}
							className="service-page__description d-flex justify-content-center align-items-start flex-column"
						>
							<div>
								<h3 className="text-upppercase">
									Built for <span>speed</span>, backed by <span>trust</span>{" "}
									your delivery.
									<br />
									Our priority. Expereince logistic delivered
								</h3>
							</div>
						</Col>
					</Row>
				</Container>

				<Container className="py-5 service-page__items">
					<Row className="g-4 py-5 justify-content-center">
						{categories.map((category, index) => (
							<Col key={index} md={4} lg={3} sm={6} xs={6}>
								<Link
									className="d-flex text-decoration-none h-100"
									to={`/services/${category.slug}`}
								>
									<ServiceCategoryCard
										image={category.icon_url}
										title={category.title}
										short_description={category.short_description}
									/>
								</Link>
							</Col>
						))}
					</Row>
				</Container>
			</section>
		</>
	);
};

export default Services;
